module.exports = __webpack_public_path__ + "img/115.131917a5.jpg";